module.exports = __webpack_public_path__ + "img/059-handbag.42e748d4.svg";